"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROPS_ORDER = exports.PropsOrderDict = void 0;

var props_id_1 = require("./entities/props-id");

var PropsOrderDict =
/** @class */
function () {
  function PropsOrderDict() {
    this._orderDict = {};
    this.setTitle(props_id_1.PropsId.targetLinks, 10);
    this.setTitle(props_id_1.PropsId.sharedWith, 20);
    this.setTitle(props_id_1.PropsId.usedBy, 30);
    this.setTitle(props_id_1.PropsId.properties, 40);
    this.setTitle(props_id_1.PropsId.health, 45);
    this.setTitle(props_id_1.PropsId.podStages, 46);
    this.setTitle(props_id_1.PropsId.labels, 50);
    this.setTitle(props_id_1.PropsId.annotations, 60);
    this.setTitle(props_id_1.PropsId.resources, 200);
    this.setTitle(props_id_1.PropsId.resourcesPerPod, 210);
    this.setTitle(props_id_1.PropsId.nodeResources, 220);
    this.setTitle(props_id_1.PropsId.poolResources, 230);
    this.setTitle(props_id_1.PropsId.clusterConsumption, 240);
    this.setTitle(props_id_1.PropsId.clusterResources, 250);
    this.setTitle(props_id_1.PropsId.appConsumption, 260);
    this.setTitle(props_id_1.PropsId.resourceRoleMatrix, 300);
    this.setTitle(props_id_1.PropsId.ingressApp, 400);
    this.setTitle(props_id_1.PropsId.ingressCidr, 410);
    this.setTitle(props_id_1.PropsId.egressApp, 420);
    this.setTitle(props_id_1.PropsId.egressCidr, 430);
    this.setTitle(props_id_1.PropsId.radioactive, 510);
    this.setTitle(props_id_1.PropsId.env, 520);
    this.setTitle(props_id_1.PropsId.mount, 530);
    this.setTitle(props_id_1.PropsId.config, 700);
    this.setTitle(props_id_1.PropsId.contents, 800);
    this.setTitle(props_id_1.PropsId.ruleAssistant, 5000);
  }

  PropsOrderDict.prototype.setTitle = function (key, value) {
    this._orderDict[key] = value;
  };

  PropsOrderDict.prototype.get = function (id) {
    var value = this._orderDict[id];

    if (value) {
      return value;
    }

    console.error("[PropsOrderDict] Could not resolve value for: %s", id); // throw new Error("Could not resolve value for: " + id);

    return 600;
  };

  return PropsOrderDict;
}();

exports.PropsOrderDict = PropsOrderDict;
exports.PROPS_ORDER = new PropsOrderDict();